export function normalizeInternalPath(path) {
  if (!path?.trim()) {
    return path;
  }

  const trimmed = path.trim();

  if (/^(https?:\/\/|mailto:|tel:|#)/i.test(trimmed)) {
    return trimmed;
  }

  const withoutTrailingSlash = trimmed.replace(/\/+$/, "") || "/";
  const slug = withoutTrailingSlash.replace(/^\/+/, "");

  return slug ? `/${slug}` : "/";
}

export function getServicePath(slug) {
  if (!slug?.trim()) {
    return "/";
  }

  const cleanSlug = slug.trim().replace(/^\/+|\/+$/g, "");

  if (cleanSlug.startsWith("service/")) {
    return normalizeInternalPath(cleanSlug);
  }

  return normalizeInternalPath(`service/${cleanSlug}`);
}
